module.exports = __webpack_public_path__ + "static/media/heart_rate-2-512.e736c0ab.png";